"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxGroup = void 0;
var tslib_1 = require("tslib");
var ui_field_label_1 = require("@hopin-team/ui-field-label");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var nanoid_1 = require("nanoid");
var react_1 = tslib_1.__importStar(require("react"));
var context_1 = require("./context");
var root_1 = require("./styled/root");
var CheckboxGroup = function (_a) {
    var __UIScope = _a.__UIScope, testID = _a["data-testid"], children = _a.children, className = _a.className, id = _a.id, legend = _a.legend, groupName = _a.name, renderLegend = _a.renderLegend, labelledBy = _a["aria-labelledby"], element = _a.element, isRequired = _a.isRequired, requiredText = _a.requiredText;
    var _b = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'Checkbox',
        className: className,
        __UIScope: __UIScope,
    }), makeClasses = _b.makeClasses, rootClasses = _b.rootClasses;
    var contextValue = (0, react_1.useMemo)(function () { return ({ groupName: groupName }); }, [groupName]);
    var fieldsetId = (0, react_1.useMemo)(function () { return id !== null && id !== void 0 ? id : (0, nanoid_1.nanoid)(); }, [id]);
    var a11yProps = {};
    if (legend) {
        a11yProps['aria-labelledby'] = fieldsetId;
    }
    if (labelledBy) {
        a11yProps['aria-labelledby'] = labelledBy;
    }
    return (react_1.default.createElement(root_1.Root, tslib_1.__assign({ className: rootClasses, "data-testid": testID, as: element }, a11yProps),
        legend && (react_1.default.createElement(ui_field_label_1.FieldLabel, { className: makeClasses('Legend'), element: "legend", isLegend: true, fieldId: fieldsetId, label: legend, isRequired: isRequired, requiredText: requiredText, mb: 2 })),
        renderLegend && renderLegend,
        react_1.default.createElement(context_1.CheckboxContext.Provider, { value: contextValue }, children)));
};
var CheckboxWithSpace = (0, ui_helper_with_space_1.withSpace)(CheckboxGroup);
exports.CheckboxGroup = CheckboxWithSpace;
//# sourceMappingURL=checkbox-group.js.map